var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuCollapse(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.0003C7.50004 10.1775 7.57545 10.3474 7.70965 10.4726L11.2874 13.8125C11.4223 13.9342 11.6031 14.0015 11.7907 14C11.9783 13.9985 12.1578 13.9282 12.2904 13.8044C12.4231 13.6805 12.4983 13.513 12.5 13.3378C12.5016 13.1627 12.4295 12.994 12.2991 12.868L9.2266 10.0003L12.2991 7.13203C12.4295 7.00605 12.5016 6.83732 12.5 6.66218C12.4983 6.48703 12.4231 6.3195 12.2904 6.19565C12.1578 6.0718 11.9783 6.00155 11.7907 6.00003C11.6031 5.9985 11.4223 6.06583 11.2874 6.18751L7.70965 9.5274C7.64312 9.5895 7.59036 9.66323 7.55438 9.74438C7.51841 9.82553 7.49993 9.91251 7.5 10.0003Z",
    fill: "#808690"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCollapse);
export default __webpack_public_path__ + "static/media/menu_collapse.41ed62f32d3050590d90c665b28b05ec.svg";
export { ForwardRef as ReactComponent };